import React from 'react';
import { TextField } from '@mui/material';
import { BaseDialog } from 'src/components/BaseDialog/BaseDialog';
import { ts, ts2 } from 'src/utils/translate';

type Props = {
    open: boolean;
    manufacturerName: string;
    editedName: string;
    disabled?: boolean;
    onChange: (newName: string) => void;
    onClose: () => void;
    onConfirm: () => void;
};

export const RenameManufacturerDialog = ({
    open,
    manufacturerName,
    editedName,
    disabled = false,
    onChange,
    onClose,
    onConfirm,
}: Props) => {
    const canConfirm = editedName.trim() !== '' && !disabled;

    return (
        <BaseDialog
            open={open}
            onClose={onClose}
            title={ts('q_manu_mod_ttl', 'Rename Manufacturer')}
            subtitle={ts2('q_manu_edit_pls', 'Please input a new name for {manufacturer} below.', { manufacturer: manufacturerName })}
            maxWidth="xs"
            cancelLabel={ts('plt_cancel', 'Cancel')}
            actionLabel={ts('plt_ok', 'OK')}
            actionDisabled={!canConfirm}
            onAction={onConfirm}
        >
            <TextField
                fullWidth
                autoFocus
                size="small"
                value={editedName}
                onChange={(event) => onChange(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' && canConfirm) onConfirm();
                }}
            />
        </BaseDialog>
    );
};
